import * as React from 'react';
import { DefaultButton, PrimaryButton, TabButton } from '@magoosh/lib/button';
import { adminPaths } from 'config/path_helpers';
import { DataTable } from '@magoosh/lib/data_table';
import { LiveClass } from '@magoosh/admin/live_class_sessions/types';
import Modal from '@magoosh/lib/modal';
import { useMemo, useState } from 'react';
import useDataQuery from '@magoosh/lib/data_table/use_data_query';
import LiveClassForm from '@magoosh/admin/live_classes/index/form';
import { QueryClient, QueryClientProvider } from 'react-query';

const LiveClassesIndex: React.FC = () => {
  const defaultQueryParams = useMemo(() => {
    const thoseParams = { filters: {} };
    return thoseParams;
  }, []);

  const { runQuery, dataQueryTableProps } = useDataQuery(
    adminPaths.api.liveClasses,
    defaultQueryParams
  );

  const [showFormModal, setShowFormModal] = useState(false);
  const [currentLiveClass, setCurrentLiveClass] = useState(null);

  const onClickNew = () => {
    setCurrentLiveClass(null);
    setShowFormModal(true);
  };

  const onClickEdit = (liveClass: LiveClass) => {
    setCurrentLiveClass(liveClass);
    setShowFormModal(true);
  };

  return (
    <div>
      <div>
        <div className="text-center">
          <TabButton href={adminPaths.liveClassSessions()}>Sessions</TabButton>
          <TabButton href={adminPaths.liveClassCohorts()}>Cohorts</TabButton>
          <TabButton disabled>Classes</TabButton>
        </div>
        <div>
          <h1>Classes</h1>
          <p>
            These are used for grouping sessions into repeating events. For example, you might have an "Intro
            to Geometry" class, with sessions occurring every 2 weeks.
          </p>
        </div>
      </div>
      <DataTable
        {...dataQueryTableProps}
        columns={[
          {
            name: 'Name',
            selector: 'name'
          },
          {
            name: 'Sessions',
            selector: 'sessionCount'
          }
        ]}>
        <DataTable.HeaderActions>
          <PrimaryButton icon="plus" onClick={onClickNew}>
            New
          </PrimaryButton>
        </DataTable.HeaderActions>
        <DataTable.ItemActions>
          {(row: LiveClass) => (
            <DefaultButton onClick={() => onClickEdit(row)} icon="edit">
              Edit
            </DefaultButton>
          )}
        </DataTable.ItemActions>
      </DataTable>
      <Modal
        onHide={() => setShowFormModal(false)}
        show={showFormModal}
        title={currentLiveClass ? `Edit ${currentLiveClass.name}` : 'New Class'}
        showCloseButton={true}>
        <div>
          <LiveClassForm
            liveClass={currentLiveClass}
            runQuery={runQuery}
            closeModal={() => setShowFormModal(false)}
          />
        </div>
      </Modal>
    </div>
  );
};

export default () => {
  const queryClient = new QueryClient();

  return <QueryClientProvider client={queryClient}>
    <LiveClassesIndex />
  </QueryClientProvider>;
};
